<template>
    <div class="centered-container">
        <SimpleModal v-if="showModal" class="activate-premium-plan-modal" :show-close-button="false" :smPadding="true"
            @close="$emit('close')">
            <template v-slot:body>
                <div class="activate-premium-plan-modal__body">
                    <div class="activate-premium-plan-modal__body__wrapper d-flex flex-column flex-lg-row gap-5">
                        <div class="activate-premium-plan-modal__body__left d-flex flex-column text-center"
                            :class="{ 'expanded': expanded }">
                            <template
                                v-if="user.prospecting_tool_attributes && !user.prospecting_tool_attributes.hasDiscount">
                                <a href="#" class="btn btn--primary btn--xs mb-4 w-fit mx-auto"
                                    style="font-size: 26px; background: #f52d2d; padding: 20px 60px;">
                                    Access expired
                                </a>

                                <p class="mx-auto" style="color: #f52d2d; max-width: 250px;">
                                    Your free trial to our market leading Stock Finder has now expired
                                </p>
                            </template>

                            <p class="mx-auto" v-if="infoText" style="color: #f52d2d; max-width: 250px;">
                                {{ infoText }}
                            </p>

                            <Transition name="slide-fade-lg" mode="out-in">
                                <div v-if="!plusPlanSelected" key="pricing-premium">
                                    <template
                                        v-if="user.prospecting_tool_attributes && user.prospecting_tool_attributes.hasDiscount">
                                        <div class="activate-premium-plan-modal__body__premium mb-2">
                                            <p class="mx-auto mb-0 d-flex gap-3 w-100 justify-content-between">
                                                <span style="color: var(--cb)">{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium.nameShort
                                                    }}</span>
                                                <span class="premium-separator" />
                                                <span class="price"><span class="price-number"><span class="line" />£{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium.subscriptionFullPrice
                                                        }}</span> {{ expanded ? 'p/m + VAT' : 'per month' }} </span>
                                            </p>
                                        </div>

                                        <div class="activate-premium-plan-modal__body__discount mb-5">
                                            <span style="color: #34cc7e">Trial period Promo discount</span>
                                            <span>£{{
                                                user.prospecting_tool_attributes.subscriptionPlans.premium.subscriptionPrice
                                                }} {{ expanded ? 'p/m + VAT' : 'per month' }} </span>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="activate-premium-plan-modal__body__premium mb-3">
                                            <p class="mx-auto mb-0 d-flex gap-3 w-100 justify-content-between">
                                                <span style="color: var(--cb)">{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium.nameShort
                                                    }}</span>
                                                <span class="premium-separator" />
                                                <span>£{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium.subscriptionFullPrice
                                                    }} {{ expanded ? 'p/m + VAT' : 'per month' }} </span>
                                            </p>
                                        </div>
                                    </template>
                                </div>
                                <div v-else key="pricing-premium-plus">
                                    <template
                                        v-if="user.prospecting_tool_attributes && user.prospecting_tool_attributes.hasDiscount">
                                        <div class="activate-premium-plan-modal__body__premium-plus mb-2">
                                            <p class="w-100 mx-auto mb-0 d-flex justify-content-between gap-3">
                                                <span>{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium_plus.nameShort
                                                    }}</span>
                                                <span class="price"><span class="price-number"><span class="line" />£{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium_plus.subscriptionFullPrice
                                                        }}</span> {{ expanded ? 'p/m + VAT' : 'per month' }} </span>
                                            </p>
                                        </div>

                                        <div class="activate-premium-plan-modal__body__discount mb-5">
                                            <span style="color: #34cc7e">Trial period Promo discount</span>
                                            <span>£{{
                                                user.prospecting_tool_attributes.subscriptionPlans.premium_plus.subscriptionPrice
                                                }} {{ expanded ? 'p/m + VAT' : 'per month' }} </span>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="activate-premium-plan-modal__body__premium-plus mb-3">
                                            <p class="w-100 mx-auto mb-0 d-flex justify-content-between gap-3">
                                                <span>{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium_plus.nameShort
                                                    }}</span>
                                                <span>£{{
                                                    user.prospecting_tool_attributes.subscriptionPlans.premium_plus.subscriptionFullPrice
                                                    }} {{ expanded ? 'p/m + VAT' : 'per month' }} </span>
                                            </p>
                                        </div>
                                    </template>
                                </div>
                            </Transition>

                            <div class="activate-premium-plan-modal__body__list w-fit mx-auto"
                                style="text-align: start;">
                                <TransitionGroup name="list" mode="out-in">
                                    <div key="unlimited">
                                        <KrispyCheckIcon />
                                        <p>
                                            Unlimited Stock Finder data - <br />
                                            <template v-if="plusPlanSelected">
                                                <span
                                                    style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                                    Sales & Lettings
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span
                                                    style="color: var(--cb); font-weight: 800; display: inline-block;">
                                                    Lettings only
                                                </span>
                                            </template>
                                        </p>
                                    </div>
                                    <template v-if="plusPlanSelected">
                                        <div key="company-landlord-access">
                                            <KrispyCheckIcon />
                                            <p>
                                                Unlimited
                                                <span
                                                    style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                                    Company landlord
                                                </span>
                                                details
                                            </p>
                                        </div>
                                        <div key="hmo-access">
                                            <KrispyCheckIcon />
                                            <p>
                                                Unlimited
                                                <span
                                                    style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                                    HMO ownership
                                                </span>
                                                details
                                            </p>
                                        </div>
                                        <div key="land-locator-access">
                                            <KrispyCheckIcon />
                                            <p>
                                                Unlimited
                                                <span
                                                    style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;">
                                                    Land Locator
                                                </span>
                                                access
                                            </p>
                                        </div>
                                    </template>
                                    <div key="no-of-postcodes">
                                        <KrispyCheckIcon />
                                        <p>Up to
                                            <Transition name="slide-fade-sm" mode="out-in">
                                                <span style="font-weight: 800; display: inline-block;"
                                                    class="primary-text-color" v-if="!plusPlanSelected"
                                                    key="no-of-postcodes">
                                                    {{
                                                        user.prospecting_tool_attributes.subscriptionPlans.premium.postcodes
                                                    }}
                                                </span>
                                                <span
                                                    style="color: var(--premium-plus-color); font-weight: 800; display: inline-block;"
                                                    v-if="plusPlanSelected" key="no-of-postcodes-plus">
                                                    {{
                                                        user.prospecting_tool_attributes.subscriptionPlans.premium_plus.postcodes
                                                    }}
                                                </span>
                                            </Transition>
                                            postcodes
                                        </p>
                                    </div>
                                    <div key="auto-matching">
                                        <KrispyCheckIcon />
                                        <p>Database auto matching</p>
                                    </div>
                                    <div key="enquiries">
                                        <KrispyCheckIcon />
                                        <p>Qualified tenant enquiries</p>
                                    </div>
                                    <div key="free-feed">
                                        <KrispyCheckIcon />
                                        <p>Free feed integration</p>
                                    </div>
                                </TransitionGroup>
                            </div>

                            <div class="mt-4 text-start" v-show="expanded">
                                <div class="activate-premium-plan-modal__plan-selection premium"
                                    :class="{ 'active mb-4': !plusPlanSelected, 'mb-2': plusPlanSelected }"
                                    @click="formData.plan_type = 'premium'" key="premium">
                                    {{ user.prospecting_tool_attributes.subscriptionPlans.premium.nameShort }} - {{
                                        user.prospecting_tool_attributes.subscriptionPlans.premium.postcodes }} postcodes
                                </div>
                                <h2 class="activate-premium-plan-modal__plan-selection__title primary-text-color mb-3"
                                    :class="{ 'd-none': plusPlanSelected }">Want to get even more?</h2>
                                <div class="activate-premium-plan-modal__plan-selection premium-plus mb-2"
                                    :class="{ 'active': plusPlanSelected }" @click="formData.plan_type = 'premium_plus'"
                                    key="premium-plus">
                                    {{ user.prospecting_tool_attributes.subscriptionPlans.premium_plus.nameShort }} - {{
                                        user.prospecting_tool_attributes.subscriptionPlans.premium_plus.postcodes }}
                                    postcodes
                                </div>
                            </div>

                            <button v-show="!expanded" type="button"
                                class="btn btn--primary btn--xs mx-auto get-started-btn"
                                @click.prevent="expanded = true">
                                Get started
                            </button>

                            <button type="button" class="btn btn--transparent-outlined mt-auto"
                                @click.prevent="expanded = false; $emit('close')">
                                Maybe later
                            </button>
                        </div>

                        <div class="activate-premium-plan-modal__body__right" v-show="expanded">
                            <h5>Please accept our subscription Terms & Conditions</h5>
                            <div class="custom-separator" />
                            <div class="activate-premium-plan-modal-tc">
                                <p>
                                    Hi {{ user.public_name }},
                                </p>
                                <p v-if="selectedPlan">
                                    Thank you for choosing to upgrade to our {{ selectedPlan.name }} - giving you more
                                    value from one of the
                                    UK's fastest growing property portal for Estate Agents.
                                </p>
                                <p>
                                    Below you'll find a breakdown of your contract and associated terms.
                                </p>
                                <p>
                                    Once you've signed the agreement and completed your Direct Debit mandate, we'll have
                                    you up and running and
                                    taking advantage our full suite of live tools, and not to mention all of the other
                                    tools we'll be launching
                                    in no time!
                                </p>
                                <p>
                                    We look forward to working with you!
                                </p>
                                <p>
                                    The krispyhouse.com Team
                                </p>
                                <strong class="mt-5" v-if="selectedPlan">
                                    {{ selectedPlan.name }} Breakdown
                                </strong>
                                <p v-if="selectedPlan">
                                    Your Stock Finder account includes up to {{ selectedPlan.postcodes }} out code
                                    districts. More can be
                                    requested and any additional out codes districts will be subject to a price change.
                                </p>
                                <p v-if="selectedPlan">
                                    {{ selectedPlan.name }} package cost:
                                </p>
                                <p v-if="selectedPlan">
                                    Subtotal: £{{ selectedPlan.subscriptionPrice }}
                                </p>
                                <p v-if="selectedPlan">
                                    VAT: £{{ selectedPlan.subscriptionVAT }}
                                </p>
                                <p v-if="selectedPlan">
                                    Total: £{{ selectedPlan.subscriptionPriceWithVAT }}
                                </p>
                                <p>
                                    Effective date: {{ new Date().toLocaleDateString("en-GB", {
                                        year: 'numeric', month:
                                            'long', day: 'numeric'
                                    })
                                    }}
                                </p>
                                <h5>Terms & Conditions.</h5>
                                <p>
                                    By completing this Subscription Agreement you confirm that you have read, understood
                                    and accept our
                                    <a href="/agent-terms-and-conditions" target="_blank">Agent Terms and Conditions</a>
                                    and
                                    <a href="/privacy-policy" target="_blank">Privacy Policy.</a>
                                    By signing the Subscription Agreement you certify that you are authorised to sign
                                    and enter into this
                                    legally binding contract, on behalf of the company you are representing.
                                </p>
                                <p>
                                    A signed Subscription Agreement and any documents expressly referred to in the
                                    Subscription Agreement
                                    represents the entire agreement between Krispyhouse Ltd t/a krispyhouse.com and you
                                    (as the client) and
                                    supersede all previous arrangements, understanding or agreement between us.
                                </p>
                                <h5>
                                    Agreement Term:
                                </h5>
                                <p v-if="selectedPlan">
                                    The term of this Subscription Agreement shall commence on the Effective Date and
                                    continue thereafter for a
                                    period of {{ selectedPlan.contractLength }} months (“Initial Term”).
                                    <span
                                        v-if="user.prospecting_tool_attributes.hasDiscount && formData.plan_type === 'premium_plus'">
                                        The first 6 months will be charged at the discounted rate of £{{
                                            selectedPlan.subscriptionPrice }} + VAT then
                                        increasing to the non discounted rate of £{{ selectedPlan.subscriptionFullPrice
                                        }} + VAT for the remaining period.
                                    </span>
                                    Unless otherwise terminated in accordance with the Terms and Conditions, upon the
                                    expiration of the Initial
                                    Term, the Subscription Agreement will automatically renew for successive
                                    {{ selectedPlan.contractLength === 6 ? 'six' : 'twelve' }} ({{
                                        selectedPlan.contractLength }}) month periods
                                    <span v-if="user.prospecting_tool_attributes.hasDiscount">
                                        at the non-discounted rate of £{{ selectedPlan.subscriptionFullPrice }} + VAT
                                        per month,
                                    </span>unless either party provides the other with written notice of non-renewal at
                                    least thirty (30) days
                                    prior to the expiration of the then-current Term. “Term” means the Initial Term and
                                    any renewal terms(s) of
                                    this Subscription Agreement.
                                </p>
                                <p>
                                    All additional postcode sectors added during the Initial Term will be added for the
                                    remainder of the Initial
                                    Term on an bi-annual pro-rata basis and will renew on the terms above.
                                </p>
                            </div>
                            <div class="activate-premium-plan-modal__form mt-4 px-2">
                                <div class="d-flex gap-2 form-group">
                                    <div class="w-50">
                                        <input class="form-control" name="firstname" v-model="formData.firstname"
                                            v-validate="{ required: true, min: 1, max: 20 }" data-vv-as="first name"
                                            placeholder="First name" />
                                        <span class="form-error">{{ errors.first('firstname') }}</span>
                                    </div>
                                    <div class="w-50">
                                        <input class="form-control" name="lastname" v-model="formData.lastname"
                                            v-validate="{ required: true, min: 1, max: 20 }" data-vv-as="last name"
                                            placeholder="Last name" />
                                        <span class="form-error">{{ errors.first('lastname') }}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" name="companyname" v-model="formData.company_name"
                                        v-validate="{ required: true, min: 1, max: 50 }" data-vv-as="company name"
                                        placeholder="Company name" />
                                    <span class="form-error">{{ errors.first('companyname') }}</span>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex gap-2">
                                        <input type="checkbox" name="terms" v-model="formData.terms"
                                            v-validate="{ required: true }" data-vv-as="accept terms" />
                                        <span>I confirm that I have read and accept to be bound by the <a
                                                href="/terms-and-conditions" target="_blank">Terms & Conditions</a> and
                                            that I am an authorised company signatory</span>
                                    </div>
                                    <span class="form-error">{{ errors.first('terms') }}</span>
                                </div>

                                <button type="submit" class="btn btn--primary btn--xs mx-auto get-started-btn w-100"
                                    :disabled="errors.any() || isLoading" @click.prevent="onActivate">
                                    Activate
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SimpleModal>
    </div>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';
import { redirectTo } from '@helpers/url-handler';
import { mapState } from 'vuex';

const KrispyCheckIcon = () => import('@components/partials/icons/KrispyCheckIcon.vue');

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
        KrispyCheckIcon,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        infoText: {
            type: String,
            required: false,
        },
        preselectedPlan: {
            type: String,
            required: false,
            default: 'premium_plus',
        },
    },
    data() {
        return {
            expanded: true,
            formData: {
                firstname: '',
                lastname: '',
                company_name: '',
                terms: false,
                plan_type: '',
            },
            isLoading: false,
        };
    },
    computed: {
        ...mapState('user', ['user']),
        plusPlanSelected() {
            return this.formData.plan_type === 'premium_plus';
        },
        selectedPlan: {
            get() {
                return this.user.prospecting_tool_attributes.subscriptionPlans[this.formData.plan_type];
            },
            set(value) {
                this.formData.plan_type = value;
            },
        },
    },
    methods: {
        onActivate() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.axios.post('/api/subscriptions/activate', this.formData)
                        .then(({ data }) => {
                            if (data && data.redirect_flows && data.redirect_flows.redirect_url) {
                                redirectTo(data.redirect_flows.redirect_url);
                            }
                        })
                        .catch(() => {
                            window.showToastError('An error occured while trying to activate your plan. Please contact krispyhouse support team.');
                            this.isLoading = false;
                        });
                }
            });
        },
    },
    watch: {
        showModal() {
            if (this.showModal) {
                this.formData.plan_type = this.preselectedPlan;
                this.selectedPlan = this.preselectedPlan;
                this.expanded = this.preselectedPlan === 'premium_plus';
            }
        },
    },
};
</script>
